import React from "react";
import {Link as RouterLink} from "react-router-dom";
import LoaderButton from "../components/LoaderButton";
import {Card, CardContent, Grid, Link} from "@mui/material";

export default function Settings() {
    return (<>
        <Card>
            <CardContent>
                <Grid container
                      spacing={3}
                      direction={"column"}
                      justifyContent={"center"}
                      alignItems={"center"}
                >
                    <Grid item>
                        <Link to="/settings/password" component={RouterLink}>
                            <LoaderButton
                                size="large"
                                variant={"contained"}
                                color={"primary"}
                            >
                                Change Password
                            </LoaderButton>
                        </Link>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
        </>
    );
}
